import { NavLink } from "react-router-dom";

export default function UserDashAdsNav() {
  const trans={
    plans:{fa:"پلن‌ها",en:"Plans"},
   
  }
  return (
    <div className="dashboardNavigator d-flex">
      <NavLink
        to={`/${window.lang}/dashboard/user/ads/plans`}
        className={`sidebarListItem m-1 link  ${({ isActive }) => {
          return isActive && "active";
        }}`}
      >
        {trans.plans[window.lang]}
      </NavLink>
      {/* <NavLink to={`/${window.lang}/dashboard/user/ads/myplans`} className={`sidebarListItem m-1 link  ${({isActive})=>{return isActive && "active" }}`}>پلن‌های من</NavLink> */}
      {/* <NavLink to={`/${window.lang}/dashboard/user/ads/reports`} className={`sidebarListItem m-1 link  ${({isActive})=>{return isActive && "active" }}`}>گزارش</NavLink>
        <NavLink to={`/${window.lang}/dashboard/user/ads/billboard`} className={`sidebarListItem m-1 link  ${({isActive})=>{return isActive && "active" }}`}>بیلبورد من</NavLink> */}
    </div>
  );
}
